import * as React from 'react';
import PropTypes from 'prop-types';
import Collapse from '@mui/material/Collapse';
import IconButton from '@mui/material/IconButton';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import {RaikoCollapsibleTableContainer} from "./RaikoCollapsiblleTableContainer";
import "./RaikoCollapsibleStyleSheet.scss"
import RaikoGridOneColumn from "../raikoCustomGrids/RaikoGridOneColumn";
import {css} from "@emotion/css";
import Pagination from "@mui/material/Pagination";
import {useState} from "react";
import Box from "@mui/material/Box";
import {Skeleton} from "@mui/material";
import {Player} from "@lottiefiles/react-lottie-player";
import emptyList from "../../assets/lottie/notFund.json";

export const RaikoCollapsibleTable = (
    {
        header = [],
        data = [],
        pageCount = 5,
        isLoading = false,
        handlePaginationChange,
        className
    }) => {

    const [page, setPage] = useState(1);

    return (
        <RaikoGridOneColumn

            className={`${
                css`
                  flex-grow: 1 !important;
                  overflow-y: hidden;
                  overflow-x: scroll !important;
                  max-width: 95vw !important;
                `
            } ${className}`}
        >
            {!isLoading && data && data.length > 0 && <TableContainer className={`hideScroll`}>
                <Table aria-label="collapsible table">
                    <TableHead>
                        <TableRow>
                            <TableCell
                                style={{width: "fit-content", flexGrow: 0,maxWidth:"50px"}}>
                            </TableCell>

                            {header.map((column) => {
                                return <TableCell
                                    key={column.id}
                                    align={column.align}
                                    style={{minWidth: column.minWidth}}
                                >
                                    {column.label}
                                </TableCell>
                            })}
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {data.map((row, key) => (
                            <Row key={key} row={row} header={header}/>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>}

            {pageCount && pageCount > 0 && !isLoading && data.length > 0 ? <div
                className={css`
                  width: 100%;
                  display: flex;
                  justify-content: center;
                  align-content: center;
                `}>
                <Pagination
                    count={pageCount}
                    shape="rounded"
                    page={page}
                    onChange={(event, value) => {
                        setPage(value)
                        handlePaginationChange(value - 1)
                    }}
                />
            </div>:""}

            {isLoading && <Box className={css`width: 100%;
              padding: 0 16px;
              gap: 16px;
              display: flex;
              flex-direction: column`}>
                <Skeleton variant="rectangular" className={css`padding: 32px`}/>
                <Skeleton variant="rectangular" className={css`padding: 16px`}/>
                <Skeleton variant="rectangular" className={css`padding: 16px`}/>
                <Skeleton variant="rectangular" className={css`padding: 16px`}/>
                <Skeleton variant="rectangular" className={css`padding: 16px`}/>
                <Skeleton variant="rectangular" className={css`padding: 16px`}/>
            </Box>}

            {!isLoading && data && data.length === 0 && <section
                className={css`
                  overflow: hidden !important;
                `}
            >
                <div
                    className={css`
                      display: flex;
                      flex-direction: column;
                      border: 2px dashed var(--outlined-input-border-color);
                      transition: var(--base-transition);
                      border-radius: var(--default-border-radius);
                      margin: 0 16px !important;
                      padding: 16px 8px !important;
                    `}
                    style={{justifyContent: 'center', alignItems: 'center'}}>
                    <Player
                        src={emptyList}
                        loop
                        autoplay
                        style={{height: '200px', width: '200px'}}
                    />
                    <span
                        className={css`
                          font-size: var(--text-size-medium);
                          color: var(--color-text);
                          margin: 8px 0;
                          transition: var(--base-transition);
                        `}>
                                    هیچ اطلاعاتی یافت نشد !
                                </span>
                    <span
                        className={css`
                          font-size: var(--text-size-default);
                          color: var(--color-variant);
                          margin: 8px 0;
                          transition: var(--base-transition);
                        `}>
                                    فیلتر ها را تغییر دهید یا از کلمات متداول تر برای جستجو استفاده نمایید.
                                </span>
                </div>
            </section>}

        </RaikoGridOneColumn>
    )
}

export function createCollapsedTableRowData(id, children, items) {
    return {
        id,
        children,
        ...items
    };
}

function Row(props) {
    const {row, header} = props;
    const [open, setOpen] = React.useState(false);

    return (
        <>
            <TableRow
                hover
                tabIndex={-1}
                key={row.id}
                className='cursorPointer'
                onClick={() => setOpen(!open)}
            >
                <TableCell align="right">
                    <IconButton
                        className={"collapsedTableIconContainer"}
                        size="small">
                        {open ? <KeyboardArrowUpIcon/> : <KeyboardArrowDownIcon/>}
                    </IconButton>
                </TableCell>

                {header.map((column, columnIndex) => {
                    const cellValue = row[column.id]
                    return (
                        <TableCell key={columnIndex} align="right">
                            {cellValue}
                        </TableCell>
                    )
                })}
            </TableRow>
            <TableRow className={"collapsedTableContainer"}>
                <TableCell style={{paddingBottom: 0, paddingTop: 0}} colSpan={12}>
                    <Collapse in={open} timeout="auto" unmountOnExit>
                        <RaikoCollapsibleTableContainer children={row.children}/>
                    </Collapse>
                </TableCell>
            </TableRow>
        </>
    );
}

RaikoCollapsibleTable.propTypes = {
    header: PropTypes.array.isRequired,
    data: PropTypes.array.isRequired,
    isLoading: PropTypes.bool,
    pageCount: PropTypes.number,
    handlePaginationChange: PropTypes.func
}